// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__3x6yB","infoBtn":"quickbooks_infoBtn__3B7Qg","formBox":"quickbooks_formBox__3-gRj","formFooter":"quickbooks_formFooter__O1eBE"};